const FrameState = {
    isLoading: false,
    setIsLoading: () => {},
    unsetIsLoading: () => {},
}

export default FrameState;
